import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Navbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: localStorage.getItem('username')
    };
  }

  componentWillReceiveProps() {
    this.setState({
      'username': localStorage.getItem('username')
    });
  }

  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/logout">
            <i className="fa fa-sign-out"></i> Çıkış
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }



  render() {

    var userLinkTitle = this.state.username ? this.state.username : 'Kullanici';

    return (

    
    <div className="container">
      <div className="d-flex pt-4 pb-4">
        
        
        
        
                  <NavLink exact className="nav-link" activeClassName="active" to="/">
                    <img alt="" src="/images/anadolu-efes-logo.svg" height="48" />
                  </NavLink>
            
 		  <nav className="navbar navbar-expand-lg ms-auto">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <NavLink exact className="nav-link text-white" activeClassName="active" to="/">
                    Anasayfa
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink exact className="nav-link text-white" activeClassName="active" to="/">
                    İletişim
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink exact className="nav-link" activeClassName="active" to="/">
                    <img alt="" src="/images/hesap.svg" height="18" />
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink exact className="nav-link" activeClassName="active" to="/">
                    <img alt="" src="/images/sepet.svg" height="18" />
                  </NavLink>
                </li>
              </ul>
          
            
          </nav>


      </div>
     </div>
    );
  }
}

export default Navbar



// WEBPACK FOOTER //
// src/components/navbar.jsx